import React from 'react';

import { styled } from '@compiled/react';

import Skeleton from '@atlaskit/skeleton';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const SkeletonWrapper = styled.span({
	display: 'inline-block',
});

export const SkeletonText = ({ length }: { length: string | number }) => (
	<SkeletonWrapper>
		<Skeleton width={length} height="1em" borderRadius="0.5em" />
	</SkeletonWrapper>
);
